import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e11f935a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e11f935a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11f935a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e11f935a')) {
      api.createRecord('e11f935a', component.options)
    } else {
      api.reload('e11f935a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e11f935a&scoped=true", function () {
      api.rerender('e11f935a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system/addMenu/index.vue"
export default component.exports